import moment from 'moment-timezone';

export const getCanonicalDayByIsoWeekday = (isoWeekday: number, timezone: string): moment.Moment => {
  const start = moment.unix(0).tz(timezone).startOf('day');
  while (start.isoWeekday() !== isoWeekday) {
    start.add(1, 'day');
  }
  return start;
};
